/** Shared naming rules for questionnaire variables, including upload filename prefixes. */
export const VARIABLE_NAME_PATTERN = /^[a-zA-Z_][a-zA-Z0-9_]{2,49}$/;
